( $ => {
  const scrollBtn = $( '.bs-section--careers-banner .bs-pro-button' ),
    notificationBar = $( '.notification-top-bar__wrapper' );
  if ( scrollBtn.length > 0 ) {
    scrollBtn.on( 'click', e => {
      const $this = $( '#current-jobs' );
      const topPosition = notificationBar.find( '.notification-top-bar' ).data( 'duration' )
        ? $( $this ).offset().top - ( 60 + notificationBar.height() )
        : $( $this ).offset().top - 60;
      e.preventDefault();
      window.scrollTo( { top: topPosition, behavior: 'smooth' } );
    } );
  }
} )( jQuery );
